<template>
    <el-container class="changePwd">
        <el-main class="pageMain">
            <div class="fixedHeader">
                修改密码
                <div class="rightBox">
                    <el-button size="mini" type="primary" @click="login('form')">确认</el-button>
                </div>
            </div>
            <el-form ref="form" :rules="rules" label-width="110px" :model="loginData" style="width: 460px;margin: 0px auto;">
                <el-form-item prop="old" class="" label="原密码">
                    <el-input placeholder="请输入原密码" show-password v-model.trim="loginData.old"></el-input>
                </el-form-item>
                <el-form-item prop="newPass" class="" label="新密码">
                    <el-input placeholder="请输入新密码" show-password v-model.trim="loginData.newPass"></el-input>
                </el-form-item>
                <div style="width: 340px;margin: -10px auto 10px auto;margin-left: 110px;">
                    <password-strength v-model="loginData.newPass" style="padding-top: 10px;"></password-strength>
                </div>
                <el-form-item prop="pwd2" class="" label="确认密码">
                    <el-input placeholder="请再次输入密码" show-password v-model.trim="loginData.pwd2"></el-input>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>
<script>
    import {userApi} from "@/api/organization";
    import PasswordStrength from "@/components/PasswordStrength.vue";

    export default {
        name: "changePwd",
        components:{PasswordStrength},
        data() {
            const validatePass = (rule, value, callback) => {
                const pattern = new RegExp('^(?=.*[a-zA-Z])(?=.*\\d).{8,16}$')
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if (!pattern.test(value)) {
                  callback(new Error('密码必须由8-16位的数字和大小写字母组成'))
                } else {
                    if (this.loginData.pwd2 !== '') {
                        this.$refs.form.validateField('pwd2');
                    }
                    callback();
                }
            };
            const validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.loginData.newPass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                loginData: {
                    old: "",
                    newPass: "",
                    pwd2: "",
                },
                rules: {
                    newPass: [
                        {required: true, message: "请输入新密码", trigger: "blur"},
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    pwd2: [
                        {required: true, message: "请再次输入密码", trigger: "blur"},
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    old: [{required: true, message: "请输入原密码", trigger: "blur"}],
                },
            }
        },
        methods: {
            login(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        userApi.changeSelfPassword(this.loginData).then(r=>{
                            if(r.data.result === 0){
                                this.$alert('密码修改成功，请重新登录。点击确定后退出。', '修改成功', {
                                    confirmButtonText: '确定',
                                    callback: () => {
                                        this.$router.push("/login");
                                    }
                                });
                            }
                        })
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .changePwd{
        width: 800px;
        margin: 0 auto;
    }
</style>
